import { useQuery } from '@tanstack/vue-query';
import axios from 'axios';

const fetchEvents = (venueId: string | number) =>
  axios({ url: `/api/events/getsportfeed/${venueId}`, timeout: 10000 });

const useSportEventsQuery = (venueId: string | number) => {
  return useQuery({
    queryKey: ['sportEvents'],
    queryFn: () => fetchEvents(venueId),
    retry: 3,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    staleTime: 1000 * 60 * 60 * 24,
  });
};

export default useSportEventsQuery;
